export function get_holster_image_file({
	holster_line_name,
	clip_material,
	image_holster_size_name,
	image_barrel_length,
	pistol_light_file_name,
	color_image_file_name,
}: {
	holster_line_name: string
	clip_material?: `Metal` | `Plastic` | null | undefined
	image_holster_size_name: string
	image_barrel_length: number
	pistol_light_file_name: string
	color_image_file_name: string
}) {
	const file_name_parts: (string | number)[] = [ holster_line_name ]

	if (clip_material) {
		file_name_parts.push(clip_material.toLowerCase())
	}

	file_name_parts.push(
		image_holster_size_name,
		image_barrel_length,
		pistol_light_file_name,
		color_image_file_name
	)

	return file_name_parts.join(`_`) + `.png`
}

export function get_accessory_image_file({
	holster_line_name,
	accessory_image_file_name,
	belt_loop_size,
	color_image_file_name,
}: {
	holster_line_name: string
	accessory_image_file_name?: string | undefined
	belt_loop_size?: `1.5"` | `1.75"` | undefined
	color_image_file_name: string
}) {
	const file_name_parts: string[] = []

	if (holster_line_name) {
		file_name_parts.push(`${ holster_line_name }_attachment`)
	}

	if (accessory_image_file_name) {
		file_name_parts.push(accessory_image_file_name)
	}

	if (belt_loop_size) {
		file_name_parts.push(`beltloop${ belt_loop_size === `1.5"` ? 150 : 175 }`)
	}

	file_name_parts.push(color_image_file_name)

	return `${ file_name_parts.join(`_`) }.png`
}
